import { SidenavRow } from '@app/components/layout/sidenav/base';
import {
  getSidenavRailPaddingLeft,
  SIDENAV_TOKENS,
} from '@app/components/layout/sidenav/sidenav-tokens';
import { useSidenavContext } from '@app/components/layout/sidenav/SidenavContext';
import { VersionUpdateSidebarButton } from '@app/core/version-check/VersionUpdateSidebarButton';
import { Box } from '@mui/material';
import { SidenavNotificationsButton } from '../notifications/SidenavNotificationsButton';
import { SidenavBrandMark } from './SidenavBrandMark';
import { SidenavChangeUserButton } from './SidenavChangeUserButton';
import { SidenavTenantLogo } from './SidenavTenantLogo';

/**
 * Top sidenav row: mini brand (+ tenant logo / change-user when impersonating) on the left,
 * notifications (and version status) on the right.
 */
export function SidenavIdentityRow() {
  const { collapsed } = useSidenavContext();
  const tokens = SIDENAV_TOKENS;
  // Same centerline as collapsed nav icons / avatar — keeps the mark from shifting on toggle.
  const brandPaddingLeft = getSidenavRailPaddingLeft(tokens.brandMarkHeight);

  return (
    <SidenavRow
      sx={{
        height: tokens.identityRowHeight,
        minHeight: tokens.identityRowHeight,
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 0.5,
        flexWrap: 'nowrap',
        position: 'relative',
        pl: `${brandPaddingLeft}px`,
        pr: tokens.contentPaddingX,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <SidenavBrandMark />
        <SidenavTenantLogo />
        <SidenavChangeUserButton />
      </Box>
      {!collapsed && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 'auto' }}>
          <VersionUpdateSidebarButton />
          <SidenavNotificationsButton />
        </Box>
      )}
    </SidenavRow>
  );
}
